type LinkIosManifestParams = {
  pwaNamePrefix?: string;
  appId?: string;
  projectName: string;
  startUrl: string;
  images: {
    192: string;
    512: string;
  };
};

/**
 * Ссылки в динамическом манифесте должны быть абсолютные, иначе iOS их не понимает
 */
export const linkIosManifest = (params: LinkIosManifestParams) => {
  const { pwaNamePrefix, appId, projectName, startUrl, images } = params;
  const link = document.createElement('link');

  const prefixContent = [pwaNamePrefix, appId].filter(Boolean).join('-');
  const prefix = prefixContent ? `[${prefixContent}] ` : '';

  const appName = `${prefix}${projectName}`;

  /**
   * Динамический манифест позволяет передать queryParams из /install/ в установленный PWA.
   * Полезно для utm-меток и query-параметров для тестирования (appId)
   */
  const manifestContent = {
    name: appName,
    short_name: appName,
    start_url: startUrl,
    display: 'standalone',
    icons: [
      {
        src: images[192],
        type: 'image/png',
        sizes: '192x192',
      },
      {
        src: images[512],
        type: 'image/png',
        sizes: '512x512',
      },
    ],
  };

  const href = `data:application/manifest+json,${encodeURIComponent(JSON.stringify(manifestContent))}`;

  link.rel = 'manifest';

  link.href = href;
  document.head.appendChild(link);
};
